import React from 'react'

const NewsEvents = () => {
  return (
    <div>NewsEvents</div>
  )
}

export default NewsEvents